import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-heading font-semibold text-background-50 mb-4">91.com</h3>
            <p className="text-sm text-background-300 leading-relaxed">
              综合性网络平台，为用户提供官方入口导航、使用指南、功能介绍及常见问题解答等全方位服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-300">
              <span>客服邮箱：support@91.com</span>
              <span>工作时间：工作日 9:00-18:00</span>
              <div className="flex gap-4 mt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-background-50"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 91.com 版权所有 | 本站为非官方导航站，仅为用户提供信息汇总服务
          </p>
          <div className="flex items-center gap-4 text-xs text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}